import { useState, useEffect } from 'react';
import { getAvailableSlots } from '../services/api';
import type { AvailableSlot } from '../types/api';

export function useAvailableSlots(serviceId: number | null, date: string | null) {
  const [slots, setSlots] = useState<AvailableSlot[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!serviceId || !date) {
      setSlots([]);
      return;
    }

    async function fetchSlots() {
      try {
        setLoading(true);
        setError(null);
        const data = await getAvailableSlots(serviceId, date);
        setSlots(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch available slots');
        setSlots([]);
      } finally {
        setLoading(false);
      }
    }

    fetchSlots();
  }, [serviceId, date]);

  return { slots, loading, error };
}
